/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitesubbonustitle3Inputs */



/**
* | output |
* | --- |
* | "Yayy!" |
*
* @param {Invitesubbonustitle3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const invitesubbonustitle3 = /** @type {((inputs?: Invitesubbonustitle3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitesubbonustitle3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Yayy!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Bien!")
	return /** @type {LocalizedString} */ ("Ура!")
});
export { invitesubbonustitle3 as "inviteSubBonusTitle" }